<template>
  <v-container fluid v-show="show">
    <v-row>
      <v-col cols="12" md="6">
        <wapi-panel :title="'Договор для радара'">
          <template v-slot:content>
            <v-container fluid>
              <v-form ref="form" v-model="valid">
                <v-text-field
                  v-model="contract.name"
                  label="Название договора"
                  :rules="[rules.required]"
                  dense
                  outlined
                ></v-text-field>
                <v-select
                  v-model="contract.user_id"
                  :items="users"
                  :rules="[rules.required]"
                  item-text="name"
                  item-value="id"
                  label="Клиент"
                  dense
                  outlined
                  :disabled="userDisabled"
                ></v-select>
                <!-- <v-select
            v-model="parameter"
            :items="parameters"
            label="Параметры"
            :rules="[rules.required]"
            dense
            outlined
                ></v-select>-->
                <v-radio-group v-model="contract.status">
                  <v-radio :label="`Активный`" :value="1" dense></v-radio>
                  <v-radio :label="`Не активный`" :value="0" dense></v-radio>
                </v-radio-group>
                <!-- Дата закрытия договора -->
                <wapi-date-picker
                  v-model="contract.expiration_date"
                  :label="`Дата закрытия договора`"
                ></wapi-date-picker>

                <v-text-field
                  v-model.number="contract.max_request_count_day"
                  label="Максимальное количество запросов в сутки"
                  type="number"
                  :rules="[rules.required]"
                  dense
                ></v-text-field>
                <v-text-field
                  v-model.number="contract.limit_validtimes_in_request"
                  label="Лимит заблаговременностей в запросе"
                  type="number"
                  :rules="[rules.required]"
                  dense
                ></v-text-field>
                <v-checkbox
                  v-model="contract.is_strict_restriction"
                  :label="`Использовать строгое ограничение`"
                  dense
                ></v-checkbox>

                <v-text-field
                  v-model.number="contract.amount_contract_month"
                  label="Сумма договора в месяц"
                  type="number"
                  :rules="[rules.required]"
                  dense
                ></v-text-field>

                <v-text-field
                  v-model.number="contract.cost_request_after_limit"
                  label="Стоимость запроса если превышен суточный лимит по запросам"
                  type="number"
                  :rules="[rules.required]"
                  dense
                ></v-text-field>

                <radar-notifications v-model="contract.notification" />
                <v-combobox
                  v-model="contract.emails"
                  :items="contract.emails"
                  label="Почтовые ящики пользователя"
                  multiple
                  :rules="[rules.required]"
                  dense
                ></v-combobox>
                <div class="d-flex justify-end">
                  <v-btn v-on:click="save" text color="primary">Сохранить</v-btn>
                  <v-btn v-on:click="back" text color="error">Закрыть</v-btn>
                </div>
              </v-form>
            </v-container>
          </template>
        </wapi-panel>
      </v-col>
      <v-col cols="12" md="6">
        <wapi-panel :title="'Свойства договора'">
          <template v-slot:content>
            <v-card>
              <v-tabs background-color="primary" dark>
                <v-tab>Территории</v-tab>
                <v-tab>Параметры</v-tab>
                <v-tab-item>
                  <v-card>
                    <wapi-select-list v-model="contract.territories" :items="territories" />
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <wapi-select-list v-model="contract.parameters" :items="parameters" />
                </v-tab-item>
              </v-tabs>
            </v-card>
          </template>
        </wapi-panel>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import RadarContract from "../models/radars/RadarContract";
import rules from "../models/helpers/rules";
import WapiPanel from "../components/WapiPanel";
import RadarNotifications from "./radar/components/RadarNotifications.vue";
import WapiSelectList from "../components/WapiSelectList";
import WapiDatePicker from "../components/WapiDatePicker.vue";

export default {
  name: "RadarContractView",
  title: "Договор для радара",
  components: {
    WapiPanel,
    RadarNotifications,
    WapiSelectList,
    WapiDatePicker
  },
  props: {
    contractId: String,
    userId: String
  },
  data: function() {
    return {
      /**
       * @type RadarContract
       */
      contract: new RadarContract(),
      mode: "",
      parameters: [],
      checkedParameters: ["test1"],
      users: [],
      rules: rules,
      valid: true,
      menuExpirationDate: false,
      exRules: {
        notZero: value => value <= 0 || `Значение не должно быть = [${value}].`
      },
      show: true,
      parameter: null,
      territories: []
    };
  },
  async created() {
    await this.init();
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    async onChangeUser() {
      await this.initModel();
    },
    async init() {
      await this.$store.dispatch("SET_LOADING", true);
      this.show = false;
      if (this.contractId) {
        await this.$store.dispatch("FETCH_RADAR_CONTRACTS", {
          userId: this.userId
        });
        this.contract = this.$store.getters.RADAR_CONTRACT_BY_ID(
          this.contractId
        );
      }
      this.territories = await this.$store.dispatch("FETCH_RADAR_TERRITORIES");
      await this.initModel();
      this.$refs.form.resetValidation();
      await this.$store.dispatch("SET_LOADING", false);
      this.show = true;
    },
    async reset() {
      this.contract = {};
    },
    async initModel() {
      await this.getParameters();
      await this.getUsers();
    },
    async save() {
      if (!this.$refs.form.validate()) return;

      if (!this.contract.parameters.length) {
        this.$store.dispatch(
          "PUSH_ERROR_MESSAGE",
          "Должен быть выбран хотя бы [1] параметр!"
        );
        return;
      }

      if (!this.contract.territories.length) {
        this.$store.dispatch(
          "PUSH_ERROR_MESSAGE",
          "Должен быть выбрана хотя бы [1] территория!"
        );
        return;
      }

      await this.$store.dispatch("SET_LOADING", true);
      if (this.contract.id) {
        await this.$store.dispatch("UPDATE_RADAR_CONTRACT", this.contract);
      } else {
        let newContract = await this.$store.dispatch(
          "CREATE_RADAR_CONTRACT",
          this.contract
        );
        this.contract.id = newContract.id;
      }
      await this.$store.dispatch("SET_LOADING", false);
      this.$router.push({
        name: "RADAR_CONTRACTS_USER",
        params: { userId: this.contract.user_id }
      });
    },
    async getUsers() {
      await this.$store.dispatch("FETCH_USERS");
      this.users = this.$store.getters.USERS;
    },
    getParameters: async function() {
      this.parameters = this.$store.getters.RADAR_PARAMETERS;
    }
  },
  computed: {
    contracts() {
      return this.$store.getters.CONTRACTS;
    },
    // contract() {
    //   return this.$store.getters.CONTRACT_BY_ID(this.contractId);
    // },
    userDisabled() {
      return !!this.contract.id;
    },
    loading() {
      return this.$store.getters.LOADING;
    }
  },
  beforeRouteEnter(to, from, next) {
    next(async vm => {
      await vm.reset();
      if (vm.contractId) {
        await vm.init();
      } else {
        vm.contract = new RadarContract();
        await vm.init();
      }
    });
  }
};
</script>